import { NgClass } from "@angular/common";
import { booleanAttribute, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PeriodIdentification, YearIdentification } from "@core/domain/plan-details";
import { TranslateModule } from "@ngx-translate/core";
import { TimeslotComponent } from "../timeslot/timeslot.component";

export interface AvailableSlot {
  yearNr: number;
  periodNr: number;
  timeslots?: string[];
}

@Component({
  selector: "pa-period-selection-grid",
  templateUrl: "./period-selection-grid.component.html",
  styleUrls: ["./period-selection-grid.component.scss"],
  imports: [NgClass, TimeslotComponent, TranslateModule],
})
export class PeriodSelectionGridComponent implements OnInit {
  @Input() years!: YearIdentification[];
  @Input() periods!: PeriodIdentification[];
  @Input() availableSlots!: AvailableSlot[];
  @Input({ transform: booleanAttribute }) showTimeslots = false;
  @Input({ transform: booleanAttribute }) selectable = false;
  @Output() selectedPeriod = new EventEmitter<{ year: YearIdentification; period: PeriodIdentification }>();

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--element-period-columns",
      (this.periods?.length ? this.periods.length + 1 : 1).toString(),
    );
  }

  isAvailable(yearNr: number, periodNr: number): boolean {
    return this.availableSlots.some((slot) => slot.yearNr === yearNr && slot.periodNr === periodNr);
  }

  getTimeslots(yearNr: number, periodNr: number): string[] {
    const slot = this.availableSlots.find(
      (availableSlot) => availableSlot.yearNr === yearNr && availableSlot.periodNr === periodNr,
    );
    return slot?.timeslots ?? [];
  }

  clickOnPeriod(year: YearIdentification, period: PeriodIdentification): void {
    if (this.selectable && this.isAvailable(year.yearNr, period.periodNr)) {
      this.selectedPeriod.emit({ year, period });
    }
  }
}
